import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";

import { BehaviorSubject, Observable, of } from "rxjs";
import { catchError, finalize, map, tap } from "rxjs/operators";
import { License } from "../../models";
import { RequestLicense, RequestLicenseSet } from "../../models/messages";
import { AdminService } from "../admin.service";


@Injectable({
  providedIn: 'root'
})

export class LicenseServiceGrid extends BehaviorSubject<GridDataResult>  {

  /*-------------------------- public properties --------------------*/

  public loading: boolean = true;

  /*-------------------------- Internal properties  ------------------*/

  protected take: number = 5;

  /*-------------------------- Constructor  --------------------------*/

  constructor(protected lservice: AdminService) {

    const emptyDataResult = {
      data: [],
      total: 0
    }

    super(emptyDataResult);
  }

  /*-------------------------- public methods ------------------------*/

  query(req: RequestLicense): void {
    this.fetch(req)
      .subscribe((x) => super.next(x));
  }

  queryAll(): Observable<GridDataResult> {

    const req: RequestLicense = {

    };

    return this.fetch(req);
  }

  fetch(req: RequestLicense): Observable<GridDataResult> {

    this.take = req.take ?? 0;

    return this.lservice.getLicense$(req)
      .pipe(
        map(
          (response) =>
            <GridDataResult>{
              data: response.data
              , total: response.total
            }
        )
        , finalize(() => (this.loading = false))
      );
  }

  save(data: License[]): Observable<boolean> {

    return this.saveApi(data)
      .pipe(
        map(modifiedData => {
          return this.syncModificationsToLocal(modifiedData);
        })
        , tap(x => { super.next(x); })
        , map(() => true)
        , catchError(() => of(false))
      );
  }

  /*--------------------------- internal functions  ------------------*/

  protected saveApi(data: License[]): Observable<License[]> {

    let req: RequestLicenseSet = new RequestLicenseSet();
    req.data = data;

    return this.lservice.setLicense$(req)
      .pipe(
        map(response => response.data!)
        , finalize(() => (this.loading = false))
      );

  }

  protected syncModificationsToLocal(modifiedItems: License[]): GridDataResult {

    let totalCount = this.value.total;

    let pos: number = 0;
    let item: License = {};
    let itemMod: License = {};

    let newData: License[] = [];

    // Create a copy of our array to manipulate and return
    for (pos = 0; pos < this.value.data.length; pos++) {
      newData.push(this.value.data[pos]);
    }

    // Get each of the modified items
    for (let j = modifiedItems.length - 1; j >= 0; j--) {

      itemMod = modifiedItems[j];
      let found = false;

      // See if they exist in our data already
      for (let i = newData.length - 1; i >= 0; i--) {

        item = newData[i];

        if (item.id == itemMod.id) {

          // match was found so substitute the modification
          newData.splice(i, 1, itemMod);
          found = true;
          break;
        }
      }

      if (found == false) {
        // Not found so insert the new item at the top of the list - user can see addition then
        newData.splice(0, 0, itemMod);
        totalCount += 1;

        // Remove items from the end of the array if we now overlap the page size due to the addition
        if (newData.length > this.take)
          newData.splice(this.take, 1);
      }
    }

    // Return the updated data array
    return { data: newData, total: totalCount };
  }

}
